import { render, staticRenderFns } from "./refresh.vue?vue&type=template&id=3a18f774&scoped=true&"
import script from "./refresh.vue?vue&type=script&lang=ts&"
export * from "./refresh.vue?vue&type=script&lang=ts&"
import style0 from "./refresh.vue?vue&type=style&index=0&id=3a18f774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a18f774",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a18f774')) {
      api.createRecord('3a18f774', component.options)
    } else {
      api.reload('3a18f774', component.options)
    }
    module.hot.accept("./refresh.vue?vue&type=template&id=3a18f774&scoped=true&", function () {
      api.rerender('3a18f774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/misc/refresh.vue"
export default component.exports